import request from '@/utils/request'

// 查询【产品信息】列表
export function listCustom(params) {
  return request({
    url: '/server/custom/list',
    method: 'get',
    params: params
  })
}

// 查询【产品信息】列表
export function entityList(params) {
  return request({
    url: '/server/custom/entityList',
    method: 'get',
    params: params
  })
}

// 查询【产品信息】详细
export function getCustom(pId) {
  return request({
    url: '/server/custom/' + pId,
    method: 'get'
  })
}

//获取【产品信息】及sku 和图片 详细信息
export function getAllProductMsg(pId) {
  return request({
    url: '/server/custom/getAllProductMsg/' + pId,
    method: 'get'
  })
}




// 新增【产品信息】
export function addCustom(data) {
  return request({
    url: '/server/custom',
    method: 'post',
    data: data
  })
}


// 新增【产品信息】
export function createProduct(data) {
  return request({
    url: '/server/custom/createProduct',
    method: 'post',
    data: data
  })
}

// 修改【产品信息】并保存
export function updateProduct(data) {
  return request({
    url: '/server/custom/updateProduct',
    method: 'post',
    data: data
  })
}



// 修改【产品信息】
export function updateCustom(data) {
  return request({
    url: '/server/custom',
    method: 'put',
    data: data
  })
}

// 状态改为删除
export function delCustom(pId) {
  return request({
    url: '/server/custom/' + pId,
    method: 'DELETE'
  })
}

// 彻底删除【产品信息】
export function deleteCustom(pId) {
  return request({
    url: '/server/custom/realDelete/' + pId.pId,
    method: 'DELETE'
  })
}

// 导出【产品信息】
export function exportCustom(query) {
  return request({
    url: '/server/custom/export',
    method: 'get',
    params: query
  })
}

// 获取定制数据
export function loadBasicData(basicId) {
  return request({
    url:'/server/custom/'+ basicId + '/basic',
    method:'get'
  })
}

// 获取优选商品（普通商品）列表数据
export function loadNormalList(params) {
  return request({
    url:'/normal/list',
    method:'get',
    params:params
  })
}

//根据优选商品ID 获取商品数据
export function selectNormalById(id) {
  return request({
    url:'/normal/'+id,
    method:'get'
  })
}

//查询在线产品的所有状态数量
export function getProductStateList(){
  return request({
    url: '/normal/getProductStateList',
    method: 'get'

  })
}

//普通商品加入购物车
export function addToShoppingCart(params) {
  return request({
    url:'/normal/addToShoppingCart',
    method:'post',
    params:params
  })
}

//将我的定制发布到店铺（移入待发布）
export function moveToRelease(data) {
  return request({
    url:'/server/design/moveToRelease',
    method:'post',
    data:data
  })
}
